import {
    CardNumberElement,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js";

import { NotificationManager } from "react-notifications";

type GetCardToken = () => Promise<string | null>;
export default function useCardToken(): GetCardToken {
    const stripe = useStripe();
    const elements = useElements();

    const getCardTokenCallback = async () => {
        if (!stripe || !elements) {
            return null;
        }
        const cardNumberElement = elements.getElement(CardNumberElement);
        if (cardNumberElement) {
            const { token, error } = await stripe.createToken(
                cardNumberElement
            );
            if (error) {
                NotificationManager.error(error.message);
                console.error(error);
            } else if (token) {
                return token.id;
            }
        }
        return null;
    };

    return getCardTokenCallback;
}
